function updateUserActive() {

    // Is the tab visible / active
    if (document.visibilityState != 'visible') {
        return;
    }

    fetch('/api/user/active')
        .then(function (data) {
        })
        .catch(function (err) {
            console.log('error: ' + err);
        });
}

window.addEventListener('load', function () {
    var fetchInterval = 30000; // 30 seconds.

    updateUserActive();

    setInterval(updateUserActive, fetchInterval);
});